<template>
    <tr>
        <td>
            <template v-if="value.StartProvinceModel.IsValid == true">
                {{value.StartProvinceModel.Name}}
            </template>
            <template v-else>
                <div class="badge badge-danger mb-25"><del>{{value.StartProvinceModel.Name}}</del></div>
                <v-select-list append-to-body v-model="startProvince" v-on:input="getStartDistricts" label="Name" :options="provinces" placeholder="Başlangıç İli"></v-select-list>
            </template>
        </td>
        <td>
            <template v-if="value.StartDistrictModel.IsValid">
                {{value.StartDistrictModel.Name}}
            </template>
            <template v-else>
                <div class="badge badge-danger mb-25"><del>{{value.StartDistrictModel.Name}}</del></div>
                <v-select-list :disabled="!startProvince || startDistricts.length == 0" append-to-body v-model="startDistrict" label="Name" :options="startDistricts" placeholder="Başlangıç İlçesi"></v-select-list>
            </template>
        </td>
        <td>
            <template v-if="value.EndProvinceModel.IsValid">
                {{value.EndProvinceModel.Name}}
            </template>
            <template v-else>
                <div class="badge badge-danger mb-25"><del>{{value.EndProvinceModel.Name}}</del></div>
                <v-select-list append-to-body v-model="endProvince" v-on:input="getEndDistricts" label="Name" :options="provinces" placeholder="Bitiş İli"></v-select-list>
            </template>
        </td>
        <td>
            <template v-if="value.EndDistrictModel.IsValid">
                {{value.EndDistrictModel.Name}}
            </template>
            <template v-else>
                <div class="badge badge-danger mb-25"><del>{{value.EndDistrictModel.Name}}</del></div>
                <v-select-list :disabled="!endProvince || endDistricts.length == 0" append-to-body v-model="endDistrict" label="Name" :options="endDistricts" placeholder="Bitiş İlçesi"></v-select-list>
            </template>
        </td>
        <td class="text-center">
            <button class="btn btn-icon btn-success" v-on:click="checkLine">
                <feather-icon icon="CheckIcon"></feather-icon>
            </button>
        </td>
    </tr>
</template>

<script>
import SystemDataApi from '@/api/system-data'
export default {
    components:{
    },
    props:{
        value:Object,
        provinces:[],
    },
    data() {
        return {
            startDistricts:[],
            endDistricts:[],
        }
    },
    mounted(){
        if(this.value.StartProvinceModel.IsValid){
            this.getStartDistricts()
        }
        if(this.value.EndProvinceModel.IsValid){
            this.getEndDistricts()
        }
    },
    methods:{
        getStartDistricts(){
            if(this.value.StartProvinceModel.Id){
                SystemDataApi.District(this.value.StartProvinceModel.Id).then(response => {
                    this.startDistricts = response.data.Data
                })
            }
        },
        getEndDistricts(){
            if(this.value.EndProvinceModel.Id){
                SystemDataApi.District(this.value.EndProvinceModel.Id).then(response => {
                    this.endDistricts = response.data.Data
                })
            }
        },
        checkLine(){
            if(this.startProvince.Id && this.startDistrict.Id && this.endProvince.Id && this.endDistrict.Id){ 
                this.$set(this.value,"StartProvinceModel",{
                    Id:this.startProvince.Id,
                    Name:this.provinces.find(p=> p.Id == this.startProvince.Id).Name,
                    IsValid:true,
                })
                this.$set(this.value,"StartDistrictModel",{
                    Id:this.startDistrict.Id,
                    Name:this.startDistricts.find(d=> d.Id == this.startDistrict.Id).Name,
                    IsValid:true,
                })
                this.$set(this.value,"EndProvinceModel",{
                    Id:this.endProvince.Id,
                    Name:this.provinces.find(p=> p.Id == this.endProvince.Id).Name,
                    IsValid:true,
                })
                this.$set(this.value,"EndDistrictModel",{
                    Id:this.endDistrict.Id,
                    Name:this.endDistricts.find(d=> d.Id == this.endDistrict.Id).Name,
                    IsValid:true,
                })
            }
        }
    },
    computed:{
        startProvince:{
            get:function(){
                return this.provinces.find(b=>b.Id==this.value.StartProvinceModel.Id)
            },
            set:function(value){
                this.value.StartProvinceModel.Id = value?.Id || this.value.StartProvinceModel.Id
            }
        },
        endProvince:{
            get:function(){
                return this.provinces.find(b=>b.Id==this.value.EndProvinceModel.Id)
            },
            set:function(value){
                this.value.EndProvinceModel.Id = value?.Id || this.value.EndProvinceModel.Id
            }
        },
        startDistrict:{
            get:function(){
                return this.startDistricts.find(b=>b.Id==this.value.StartDistrictModel.Id)
            },
            set:function(value){
                this.value.StartDistrictModel.Id = value?.Id || this.value.StartDistrictModel.Id
            }
        },
        endDistrict:{
            get:function(){
                return this.endDistricts.find(b=>b.Id==this.value.EndDistrictModel.Id)
            },
            set:function(value){
                this.value.EndDistrictModel.Id = value?.Id || this.value.EndDistrictModel.Id
            }
        },
    },
}
</script>

<style>

</style>